import { resetUserPasswordRequestParamsSchema, resetUserPasswordResponseSchema } from './types';
export const resetUserPasswordDef = {
    name: 'resetUserPassword',
    requestSchema: resetUserPasswordRequestParamsSchema,
    responseSchema: resetUserPasswordResponseSchema,
};
